module.exports = __webpack_public_path__ + "img/ks.22ae5ebc.png";